<template>
  <div>
    <v-row>
      <v-col cols="12">
        <upload-area :extensoes-permitidas="extensoesPermitidas" @files:change="filesChange" />
      </v-col>
    </v-row>
    <general-progress-bars
      class="mb-11 mt-11"
      :items="uploadProgressData"
      prefix-text="Enviando"
      suffix-property="name"
      :include-hash-on-text="false"
      :truncate-text="true"
    />
    <upload-queue
      :files.sync="files"
      :upload-progress-data.sync="uploadProgressData"
      :function-service-upload="customFunctionUpload"
      :extra="parametroExtra"
      :caminho-tmp="caminhoTmp"
      @file:uploaded="handleFileUploaded"
    />
  </div>
</template>

<script>
  export default {
    components: {
      UploadArea: () => import('@/components/general/UploadFiles/UploadArea.vue'),
      UploadQueue: () => import('@/components/general/UploadFiles/UploadQueue.vue'),
      GeneralProgressBars: () => import('@/components/general/GeneralProgressBars.vue')
    },

    props: {
      customFunctionUpload: {
        type: Function,
        required: false
      },
      extensoesPermitidas: {
        type: Array,
        default: () => ['*']
      },
      parametroExtra: {
        type: Number,
        required: false
      },
      caminhoTmp: {
        type: String,
        default: null
      }
    },

    emits: ['file:uploaded', 'file:upload-in-progress'],

    data: () => ({
      files: [],
      uploadProgressData: {},
      uploadedFiles: []
    }),

    methods: {
      filesChange(file) {
        this.files.push(file);
      },

      handleFileUploaded(event) {
        const files = [event];
        files.forEach((file) => this.uploadedFiles.push(file.files));
        this.$emit('file:uploaded', event);
      }
    },

    watch: {
      uploadProgressData(newValue) {
        const isEmptyObject = !Object.keys(newValue).length;
        const uploadInProgress = isEmptyObject ? false : true;

        this.$emit('file:upload-in-progress', uploadInProgress);
      }
    }
  };
</script>
